import React from 'react'
import './CustomSiteSchedule.css'
import { WeddingSchedule } from '../../Constants'
import closeIcon from '../../Assets/Icons/close.png'

export default function CustomSiteSchedule({ schedule, open, setOpen, colourScheme }) {

    // Helper function to convert time to minutes since midnight
    function timeToMinutes(time) {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
    }

    // Function to sort events by startTime
    function sortEvents(events) {
        return events.sort((a, b) => {
            const timeA = timeToMinutes(a.startTime);
            const timeB = timeToMinutes(b.startTime);

            // Custom sorting logic: if the time is before 05:00, add 1440 minutes (24 hours) to push it to the end
            const adjustedTimeA = timeA < 300 ? timeA + 1440 : timeA;
            const adjustedTimeB = timeB < 300 ? timeB + 1440 : timeB;

            return adjustedTimeA - adjustedTimeB;
        });
    }

    // Filter visible events and sort them
    const visibleEvents = schedule?.events?.filter(event => event.visible) || [];
    const sortedEvents = sortEvents([...visibleEvents]);

    return (
        <div id='custom-site-schedule' className={`${open ? "schedule-open" : ""} ${colourScheme}-schedule`}>
            <button onClick={() => setOpen(false)} id='close-schedule-btn' className={`${colourScheme}-close-btn`}>
                <img src={closeIcon} alt="Close" style={{ width: '24px', height: '24px' }} />
            </button>

            <h3 style={{ textAlign: 'center', textTransform: 'uppercase', letterSpacing: '3px', fontSize: 16 }}>Schedule of the day</h3>

            {sortedEvents.length === 0 ? (
                <p style={{ margin: '20px 30px', color: '#666' }}>No events scheduled yet</p>
            ) : (
                sortedEvents.map((item, i) => {
                    let lastIndex = sortedEvents.length - 1;
                    let eventInfo = WeddingSchedule.find(event => event.id == item.eventId);

                    return (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', height: 120 }}>
                            <div className='timeline-container'>
                                <div className={i === 0 ? "timeline-no-line" : 'timeline-line'} />
                                <div className='timeline-dot' />
                                <div className={i === lastIndex ? "timeline-no-line" : 'timeline-line'} />
                            </div>

                            <div key={i} className='schedule-item-container'>
                                <img style={{ height: 55, marginRight: 20 }} src={eventInfo?.icon} alt={eventInfo?.name} />
                                <div style={{ display: 'flex', flexDirection: 'column', width: '70%' }}>
                                    <p style={{ fontSize: 20, textAlign: 'left', margin: 0, fontFamily: "'Noto Serif', serif" }}>
                                        {item.startTime} {item.endTime && `- ${item.endTime}`}
                                    </p>
                                    <p style={{ textTransform: 'uppercase', textAlign: 'left', margin: '5px 0', letterSpacing: '3px', fontSize: 14, fontWeight: 600 }}>
                                        {item.event}
                                    </p>

                                </div>
                            </div>
                        </div>
                    )
                })
            )}
        </div>
    )
}

